<template lang='pug'>
  div
    v-progress-circular(v-if="isAuthenticated && isLoadingAccountState" indeterminate color="accent")
    v-tooltip(v-else-if="isAccountPaid" left)
      template(v-slot:activator="{ on, attrs }")
        v-icon(@click='showPayInfo'
                color='accent'
                v-bind='attrs'
                v-on='on') star
      span {{payResource.paidAccess}}
    v-chip(v-else @click='showPayInfo' color="accent" outlined) {{payResource.free}}
</template>

<script>
import AccountStateMixin from '@/mixins/AccountStateMixin'
import payResource from '@/resources/pay'

export default {
  name: 'AccountPaidStatus',
  mixins: [AccountStateMixin],
  data: function () {
    return {
      payResource
    }
  },
  computed: {
    isLoadingAccountState: function () {
      return !this.$store.getters.isAccountLoaded
    }
  },
  methods: {
    showPayInfo (e) {
      e.target.blur()
      this.$emit('open-account-pay')
    }
  }
}
</script>
